// AB#1925/1930 — month names indexed 1..12, the single source for the `month-number` custom type.
// Read mode (formatValue) maps a stored 1..12 → the month NAME; edit mode (the month picker) offers a
// January..December select whose option values are 1..12. Both import this so the mapping never drifts.
export const MONTHS: { value: number; name: string }[] = [
    { value: 1, name: 'January' },
    { value: 2, name: 'February' },
    { value: 3, name: 'March' },
    { value: 4, name: 'April' },
    { value: 5, name: 'May' },
    { value: 6, name: 'June' },
    { value: 7, name: 'July' },
    { value: 8, name: 'August' },
    { value: 9, name: 'September' },
    { value: 10, name: 'October' },
    { value: 11, name: 'November' },
    { value: 12, name: 'December' },
]

// The month NAME for a 1..12 value, or undefined when out of range — read mode falls back to the raw value.
export function monthName(n: number): string | undefined {
    return Number.isInteger(n) && n >= 1 && n <= 12 ? MONTHS[n - 1]!.name : undefined
}
